import { WFComponent } from "@xatom/core";
import { API_ENDPOINT, PUBLIC_PATHS } from "../../config";
import { getCurrentPath, getInitials } from "../../utils";
import axios from "axios";

export const publicSidebar = async () => {
    try {
        const token = localStorage.getItem("_ms-mid");
        const topbar = new WFComponent(`[xa-type="topbar"]`);
        const sidebar = new WFComponent(`[xa-type="sidebar"]`)
        if (!topbar || !sidebar || !token) {
            console.log("We think this page doesnt have a sidebar or user not logged in");
            return;
        }

        const accDDs = topbar.getChildAsComponents(`[xa-type="account-dd"]`);
        const companyLogo = sidebar.getChildAsComponent(`[xa-type="company-logo"]`)

        const userResponse = await axios.get(`${API_ENDPOINT}/airtable/userme`, { headers: { authorization: `Bearer ${token}` } });
        const subscribedCategoriesRes = await axios.get(`${API_ENDPOINT}/airtable/subscribed/categorynames`, { headers: { authorization: `Bearer ${token}` } });
        console.log(subscribedCategoriesRes)

        if (userResponse && userResponse.data && userResponse.data.data) {
            const user = userResponse.data.data;
            accDDs.forEach(dd => {
                const profileImage = dd.getChildAsComponent(`[xa-type="image"]`);
                const ititialsBlock = dd.getChildAsComponent(`[xa-type="initials-block"]`);
                dd.updateTextViaAttrVar({
                    initials: getInitials(`${user.firstname} ${user.lastname}`),
                });

                // console.log(user.profileImage)
                // if (user.profileImage && user.profileImage !== '') {
                //     profileImage.setAttribute(`src`, user.profileImage);
                //     profileImage.setAttribute(`srcset`, user.profileImage);
                // } else {
                //     profileImage.addCssClass("hide");
                //     ititialsBlock.setStyle({
                //         display: `flex`
                //     })
                // }

                if (user.companyLogo && user.companyLogo !== "") {
                    companyLogo.setAttribute(`src`, user.companyLogo);
                    companyLogo.setAttribute(`srcset`, user.companyLogo);
                }
            })
        }

        if (subscribedCategoriesRes && subscribedCategoriesRes.data && subscribedCategoriesRes.data.data) {
            const categories = subscribedCategoriesRes.data.data;
            handleSearch(categories);
        }
    } catch (error) {
        console.log("We think this page doesnt have a sidebar", error);
    }
}

async function handleSearch(subscribedCategories) {
    const inputField = document.getElementById("autoInput");
    const searchList = document.getElementById("search-terms");
    const searchTermsWrapper = document.getElementById("searchTermsWrapper");
    const categoryItems = document.querySelectorAll("#product-category");
    const productItems = document.querySelectorAll("#product-name");

    let categories = [];
    let products = [];

    // Extract all categories (subscribed & non-subscribed)
    categoryItems.forEach(item => {
        const categoryName = (item as HTMLElement).innerText.trim();
        const categoryLink = item.closest("a")?.href || "#"; // Find nearest <a>
        categories.push({ name: categoryName, link: categoryLink });
    });

    // Extract only products from **subscribed categories**
    productItems.forEach(item => {
        const productName = (item as HTMLElement).innerText.trim();
        const productCategory = item.getAttribute("category-name")?.trim();
        const productLink = item.closest("a")?.href || "#"; // Find nearest <a>

        if (subscribedCategories.includes(productCategory)) {
            products.push({ name: productName, category: productCategory, link: productLink });
        }
    });

    function populateSearchList() {
        if (searchList) {
            searchList.innerHTML = ""; // Clear previous suggestions

            // First suggestion item (search input)
            const liFirst = document.createElement("li");
            liFirst.classList.add("suggestion-item", "first-item");
            liFirst.style.display = "none";
            liFirst.innerHTML = `<a href="#" class="list-term"></a>`;
            searchList.appendChild(liFirst);

            // Add ALL categories (subscribed & non-subscribed)
            categories.forEach(category => {
                const li = document.createElement("li");
                li.classList.add("suggestion-item");
                //console.log("current category:" ,category)
                // Add event listener for locked categories
                if (subscribedCategories.includes(category.name)) {
                    //console.log("inside if statement")
                    li.innerHTML = `<a href="${category.link}" class="list-term">${category.name}</a>`;
                } else {
                    //console.log("inside else statement")
                    li.innerHTML = `<a href="#" id="unlock-button" data-category-link='${category.name}' xa-type="unlock-btn" xa-name='${category.name}' class="list-term locked-category">${category.name}</a>`;
                    li.querySelector("a").addEventListener("click", function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        let text = li.querySelector("a").textContent;
                        openPopup(text);
                    });
                }

                searchList.appendChild(li);

            });

            // Add only products from **subscribed categories**
            products.forEach(product => {
                const li = document.createElement("li");
                li.classList.add("suggestion-item");
                li.innerHTML = `<a href="${product.link}" class="list-term">${product.name}</a>`;
                searchList.appendChild(li);
            });

            // Sort list alphabetically
            const listItems = [...(searchList as any).getElementsByTagName("LI")];
            listItems.sort((a, b) => a.innerText.localeCompare(b.innerText));
            listItems.forEach(item => searchList.appendChild(item));
        }
    }

    function typeSearch() {
        const searchKeyword = (inputField as any).value.trim();
        const firstItem = document.querySelector(".first-item");

        if (searchKeyword === "") {
            searchTermsWrapper.style.display = "none";
            (firstItem as any).style.display = "none";
            return;
        } else {
            searchTermsWrapper.style.display = "block";
            (firstItem as any).style.display = "";
            (firstItem as any).querySelector(".list-term").innerText = `Search '${searchKeyword}'`;
            firstItem.querySelector("a").href = `/explore?filter=${encodeURIComponent(searchKeyword)}`;
        }

        // Filter the list items based on input
        const filter = searchKeyword.toUpperCase();
        const li = searchList.getElementsByTagName("li");

        for (let i = 1; i < li.length; i++) { // Skip first item
            const txtValue = li[i].textContent || li[i].innerText;
            li[i].style.display = txtValue.toUpperCase().includes(filter) ? "" : "none";
        }
    }

    function checkFocus() {
        searchTermsWrapper.style.display = document.activeElement.id === 'autoInput' ? "block" : "none";
    }

    // Initialize event listeners
    if (inputField && searchTermsWrapper) {
        inputField.addEventListener("keyup", typeSearch);
        searchTermsWrapper.style.display = "none";
        document.addEventListener("mouseup", checkFocus, false);
    }

    populateSearchList();
}

function openPopup(text) {
    // console.log("popup function start");

    let popups = document.querySelectorAll(".search-wrapper .unlock-popup");
    // console.log("Found popups:", popups.length);

    popups.forEach(popup => {
      let popupText = popup.getAttribute("data-popup")?.trim().toLowerCase();
      let inputText = text.trim().toLowerCase();

      //  console.log(`Checking popup: ${popupText} against ${inputText}`);

      if (inputText === popupText) {
        // console.log("Target popup found:", popup);

        // Ensure the parent container is visible if necessary
        let parent: any = popup.closest(".search-wrapper");
        if (parent) {
          parent.style.display = "block";
          // console.log("Parent container made visible");
        }

        // Ensure the popup is displayed
        setTimeout(() => {
          (popup as any).style.display = "flex";
          (popup as any).style.opacity = "1";
          (popup as any).style.visibility = "visible";
          (popup as any).style.zIndex = "9999";
        }, 100);
      }
    });
  }